export var theme = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        backgroundColor: '#fff',
        padding: '0 16px',
        overflow: 'hidden',
        position: 'relative',
    },
};
